export default class ToggleEmptyRolesModule {
  constructor(controller) {
    this.controller = controller;
    this.showEmptyFunctions = true;
  }

  initialize() {
    this.initToggleEmptyRoles();
    // Definir estado inicial dos ícones
    this.updateButtonState();
  }

  initToggleEmptyRoles() {
    if (this.controller.hasToggleEmptyFunctionsTarget) {
      this.controller.toggleEmptyFunctionsTarget.addEventListener(
        "click",
        () => {
          this.showEmptyFunctions = !this.showEmptyFunctions;

          // Alternar ícones e título do botão
          this.updateButtonState();

          // Fechar o dropdown após clicar na opção
          document.getElementById("kanban-board").click();

          // Encontra todas as funções em todos os kanbanBoards
          this.controller.kanbanBoardTargets.forEach((board) => {
            const funcaoContainers =
              board.querySelectorAll(".funcao-container");

            funcaoContainers.forEach((container) => {
              const hasChildren = container.children.length > 0;
              const funcaoHeader = container.previousElementSibling;

              if (!this.showEmptyFunctions && !hasChildren) {
                container.style.display = "none";
                if (
                  funcaoHeader &&
                  funcaoHeader.classList.contains("funcao-header")
                ) {
                  funcaoHeader.style.display = "none";
                }
              } else {
                container.style.display = "";
                if (
                  funcaoHeader &&
                  funcaoHeader.classList.contains("funcao-header")
                ) {
                  funcaoHeader.style.display = "";
                }
              }
            });
          });
        }
      );
    }
  }

  updateButtonState() {
    // Verificar se os targets dos ícones existem
    if (
      this.controller.hasEyeOpenIconTarget &&
      this.controller.hasEyeClosedIconTarget
    ) {
      const eyeOpenIcon = this.controller.eyeOpenIconTarget;
      const eyeClosedIcon = this.controller.eyeClosedIconTarget;

      if (this.showEmptyFunctions) {
        // Mostrar ícone olho fechado, esconder olho aberto
        eyeOpenIcon.classList.add("hidden");
        eyeClosedIcon.classList.remove("hidden");
      } else {
        // Mostrar ícone olho aberto, esconder olho fechado
        eyeOpenIcon.classList.remove("hidden");
        eyeClosedIcon.classList.add("hidden");
      }
    }
  }
}
